<template>
  <div>
    <top-message />
    <!--企业-->
    <div class="bottomPart bottomPartCompany" v-if="getSourceType === '1'">
      <div class="titlePart">金融产品</div>
      <el-form
        :inline="true"
        :model="searchForm"
        class="demo-form-inline"
        style="border-bottom: 1px solid #F3F4F9;padding: 0 30px"
      >
        <el-form-item label="申请时间">
          <div class="block">
            <!-- <el-date-picker
              style="width: 220px"
              v-model="searchForm.timeRange"
              @change="handleTimeChange"
              type="monthrange"
              range-separator="至"
              start-placeholder="开始"
              end-placeholder="结束"
            >
            </el-date-picker>-->
            <el-date-picker
              :editable="false"
              v-model="searchForm.startTime"
              :picker-options="startDatePicker"
              type="month"
              value-format="yyyy-MM"
              format="yyyy-MM"
              placeholder="选择开始日期"
              @change="handleTimeChange"
            />
          </div>
        </el-form-item>
        <el-form-item label="结束时间" prop="endTime">
          <el-date-picker
            :editable="false"
            v-model="searchForm.endTime"
            :picker-options="endDatePicker"
            type="month"
            value-format="yyyy-MM"
            format="yyyy-MM"
            placeholder="选择结束日期"
            @change="handleTimeChange"
          />
        </el-form-item>
        <el-form-item label="申请银行">
          <el-select
            v-model="searchForm.bankId"
            placeholder="请选择"
            style="width: 120px"
            clearable
            @change="handleChange"
          >
            <el-option
              v-for="item in bankOption"
              :key="item.bankId"
              :label="item.bankName"
              :value="item.bankId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="申请状态">
          <el-select
            v-model="searchForm.status"
            placeholder="请选择"
            style="width: 120px"
            clearable
            @change="handleChange"
          >
            <el-option
              v-for="item in statusOption"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="申请金额">
          <el-select
            v-model="searchForm.moneyRange"
            placeholder="请选择"
            style="width: 120px"
            clearable
            @change="handleMoneyChange"
          >
            <el-option
              v-for="item in moneyOption"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <!--        <el-form-item>-->
        <!--          <el-button style="background: #2981EE;border: 1px solid #2981EE" type="primary" @click="handleSubmit" icon="el-icon-search">搜索</el-button>-->
        <!--        </el-form-item>-->
      </el-form>
      <div class="contentListPart">
        <div class="contentItemPart" v-for="(item,i) in data" :key="i">
          <div class="leftPart">
            <div
              style="display: flex;align-items: center;width: 100%;padding: 0 20px;box-sizing: border-box;"
            >
              <img class="bankIcon" src="../../assets/images/gongshang1.png" alt />
              <div class="textPart">
                <div class="title">{{ item.bankName }}信用贷</div>
                <div class="textOuterPart">
                  <div class="textInnerPart">
                    <div>申请额度</div>
                    <div>
                      <span>{{ item.loanMinAmount }}-{{ item.loanMaxAmount }}</span>万
                    </div>
                  </div>
                  <div class="textInnerPart">
                    <div>授信金额</div>
                    <div>
                      <span>--.--</span>万
                    </div>
                  </div>
                  <div class="textInnerPart">
                    <div>授信利率</div>
                    <div>
                      <span>--.-</span>%
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div style="font-size: 12px">
            如需用款可登录{{ item.bankName }}企业网上银行查看详情，或联系银行客服热线：95588</div>-->
          </div>
          <div class="rightPart">
            <!-- <el-steps
              :active="item.checkStatus"
              align-center
            >-->
            <!-- 假数据 -->
            <el-steps :active="active" align-center>
              <el-step title="申请" :description="formatTime(item.createTime)" :ref="'cancel'+i" />
              <el-step title="关注" description />
              <!-- <el-step
                v-if="item.checkStatus === 2 && item.status === 8"
                title="审核拒绝"
                description=""
                status="error"
              />-->
              <!-- 
              <el-step
                v-if="item.checkStatus === 5 && item.status === 8"
                title="授信拒绝"
                description=""
                status="error"
              />-->
              <!-- <el-step
                v-else
                title="授信"
                description=""
              />-->
              <el-step title="授信" description />
              <el-step title="放款" description />
            </el-steps>
          </div>
        </div>
      </div>
    </div>
    <!--银行-->
    <div v-if="getSourceType === '2'">
      <div class="bottomPart bottomPartBank">
        <div class="titlePart">对接记录</div>
        <el-tabs v-model="activeName">
        <!-- <el-tabs v-model="activeName" @tab-click="handleClick"> -->
          <!-- <el-tab-pane label="一键授信产品" name="1">
            <el-form
              :inline="true"
              :model="searchForm"
              class="form-inline-enterprise"
              style="border-bottom: 1px solid #F3F4F9;padding: 0 30px;background:#fff"
            >
              <el-form-item label="企业名称">
                <el-input
                  style="width: 120px"
                  v-model="searchForm.appDeptName"
                  placeholder="请输入"
                  @change="handleChange"
                >
                  <i class="el-icon-search el-input__icon" slot="suffix" />
                </el-input>
              </el-form-item>
              <el-form-item label="申请时间">
                <div class="block">
                  <el-date-picker
                    :editable="false"
                    v-model="searchForm.startTime"
                    :picker-options="startDatePicker"
                    type="month"
                    value-format="yyyy-MM"
                    format="yyyy-MM"
                    placeholder="选择开始日期"
                    @change="handleTimeChange"
                  />
                </div>
              </el-form-item>
              <el-form-item label="结束时间" prop="endTime">
                <el-date-picker
                  :editable="false"
                  v-model="searchForm.endTime"
                  :picker-options="endDatePicker"
                  type="month"
                  value-format="yyyy-MM"
                  format="yyyy-MM"
                  placeholder="选择结束日期"
                  @change="handleTimeChange"
                />
              </el-form-item>
              <el-form-item label="申请状态">
                <el-select
                  v-model="searchForm.status"
                  placeholder="请选择"
                  style="width: 120px"
                  clearable
                  @change="handleChange"
                >
                  <el-option
                    v-for="item in statusOption"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="申请金额">
                <el-select
                  v-model="searchForm.moneyRange"
                  placeholder="请选择"
                  style="width: 120px"
                  clearable
                  @change="handleMoneyChange"
                >
                  <el-option
                    v-for="item in moneyOption"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <div class="footPart">
              <div class="companyList">
                <div class="companyItem" v-for="(item,i) in data" :key="i">
                  <img
                    style="width:40px;height:40px;margin:20px"
                    class="bankIcon"
                    src="../../assets/images/gongshang1.png"
                    alt
                  />
                  <div class="leftPart">
                    <div class="titlePart1">
                      <div class="title">{{ item.appDeptName }}</div>
                      <div class="info">统一代码：{{ item.appDeptCode }}</div>
                    </div>
                    <div class="textOuterPart">
                      <div class="textInnerPart">
                        <div>申请额度</div>
                        <div>
                          <span>{{ item.loanMinAmount }}-{{ item.loanMaxAmount }}</span>万
                        </div>
                      </div>
                      <div class="textInnerPart">
                        <div>授信金额</div>
                        <div>
                          <span>--.--</span>万
                        </div>
                      </div>
                      <div class="textInnerPart">
                        <div>授信利率</div>
                        <div>
                          <span>--.-</span>%
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="rightPart">
                    
                    <el-steps :active="active" align-center>
                      <el-step title="申请" :description="formatTime(item.createTime)" />
                      <el-step title="关注" description />
                      <el-step title="审核" description />
                      

                      <el-step
                        v-if="item.checkStatus === 3 && item.status === 9"
                        title="授信拒绝"
                        description
                        status="error"
                      />

                      <el-step title="授信" description />
                    </el-steps>
                  </div>
                </div>
                <div class="block2">
                    <el-pagination
                      @current-change="getSearchList"
                      layout="total, prev, pager, next"
                      :total="this.total2"
                      :current-page.sync="searchForm.page"
                    ></el-pagination>
                </div>
              </div>
            </div>
          </el-tab-pane> -->
          <el-tab-pane label="其他产品" name="2">
            <el-form
              :inline="true"
              :model="searchForm"
              class="form-inline-enterprise"
              style="border-bottom: 1px solid #F3F4F9;padding: 0 30px;background:#fff"
            >
              <el-form-item label="企业名称">
                <el-input
                  style="width: 120px"
                  v-model="historyForm.deptName"
                  placeholder="请输入"
                  @change="historyChange"
                >
                  <i class="el-icon-search el-input__icon" slot="suffix" />
                </el-input>
              </el-form-item>
              <el-form-item label="申请开始时间">
                <div class="block">
                  <!-- <el-date-picker
                    style="width: 220px"
                    v-model="timeRange"this.historyForm.endTime
                    @change="historyTimeChange"
                    type="monthrange"
                    range-separator="-"
                    start-placeholder="开始"
                    end-placeholder="结束"
                  >
                  </el-date-picker>-->
                  <el-date-picker
                    :editable="false"
                    v-model="historyForm.startTime"
                    :picker-options="historyDatePicker"
                    type="month"
                    value-format="yyyy-MM"
                    format="yyyy-MM"
                    placeholder="选择开始日期"
                    @change="historyTimeChange"
                  />
                </div>
              </el-form-item>
              <el-form-item label="申请结束时间" prop="endTime">
                <el-date-picker
                  :editable="false"
                  v-model="historyForm.endTime"
                  :picker-options="historyendDatePicker"
                  type="month"
                  value-format="yyyy-MM"
                  format="yyyy-MM"
                  placeholder="选择结束日期"
                  @change="historyTimeChange"
                />
              </el-form-item>
              <el-form-item label="申请状态">
                <el-select
                  v-model="historyForm.status"
                  placeholder="请选择"
                  style="width: 120px"
                  clearable
                  @change="historyStatusChange"
                >
                  <el-option
                    v-for="item in historyOption"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <div class="historyButton">
              <div>
                <img src="../../assets/images/Select.png" alt /> 关注后可查看企业联系方式
              </div>
              <el-button icon="el-icon-upload2" @click="otherDown">导出统计表</el-button>
            </div>
            <div class="historyTable">
              <el-table :data="tableData" style="width: 100%">
                <el-table-column style="text-align: center;" label="企业名称/统一代码">
                  <template slot-scope="scope">
                    <div
                      style="font-size: 18px;font-family: Alibaba PuHuiTi;
font-weight: 500;
color: #252525;  text-align:center"
                    >{{scope.row.enterpriseName}}</div>
                    <div
                      style="font-size: 15px;
font-family: Alibaba PuHuiTi;
font-weight: 400;
color: #252525; margin-top: 5px; text-align:center"
                    >{{scope.row.appDeptId}}</div>
                  </template>
                </el-table-column>
                <el-table-column prop="name" label="申请产品" width="180"></el-table-column>
                <el-table-column prop="appLimit" label="申请金额" width="100"></el-table-column>
                <el-table-column prop="statusName" label="申请状态" width="100"></el-table-column>
                <el-table-column prop="phone" label="联系电话" width="200">
                  <template
                    slot-scope="scope"
                  >{{scope.row.statusName=="已关注"?scope.row.legalPersonPhone:'--'}}</template>
                </el-table-column>
                <el-table-column prop="operation" label="操作" width="120">
                  <template slot-scope="scope">
                    <el-button
                      v-if="scope.row.status == 1 ||scope.row.status ==3"
                      style="width:94px;height:40px;background: #2981EE; color:#fff"
                      @click="Focus(scope.row.id,'follow')"
                    >关注</el-button>
                    <el-button
                      v-else-if="scope.row.status == 2"
                      style="width:94px;height:40px;
background: #E2EFFF; color:#2981EE"
                    >已关注</el-button>
                  </template>
                </el-table-column>
              </el-table>

              <div class="block2">
                <el-pagination
                  @current-change="getOtherListSearch"
                  layout="total, prev, pager, next"
                  :current-page.sync="historyForm.page"
                  :total="this.total"
                ></el-pagination>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getApplyList,
  getBankList,
  updateApply,
  list,
  operate,
  expertProductApplyList,
  selectProType
} from "../../api/myCenter";
import moment from "moment";
import TopMessage from "@/components/TopMessage";
import baseUrl from "@/api/baseUrl";
export default {
  components: { TopMessage },
  data() {
    return {
      active: 1,
      searchForm: {
        status: "",
        bankId: "",
        startTime: "",
        endTime: "",
        loanMinAmount: "",
        loanMaxAmount: "",
        timeRange: [],
        moneyRange: "",
        page: 1,
        pageSize: 10,
        appDeptName: ""
      },
      historyForm: {
        deptName: "",
        startTime: "",
        endTime: "",
        sourceType: "",
        status: "",
        page: 1,
        pageSize: 10
      },
      timeRange: "",
      bankOption: [],
      statusOption: [
        { value: 1, label: "已申请" },
        // { value: 2, label: "已推荐" },
        { value: 3, label: "已关注" },
        { value: 5, label: "已授信" },
        { value: 6, label: "已审核" }
        // { value: 7, label: "撤销" },
        // { value: 8, label: "授信(拒绝)" },
        // { value: 10, label: "拒绝推荐" },
      ],
      historyOption: [
        { value: 1, label: "未关注" },
        { value: 2, label: "已关注" }
      ],
      moneyOption: [
        { value: 1, label: "100万以下" },
        { value: 2, label: "100万以上" }
        // { value: 3, label: "100-200万" },
        // { value: 4, label: "200-500万" },
        // { value: 5, label: "500万以上" },
      ],
      data: [],
      activeName: "2",
      tableData: [],
      total: 0,
      total2:0,
      startDatePicker: this.beginDate(),
      endDatePicker: this.processDate(),
      historyDatePicker: this.beginDate1(),
      historyendDatePicker: this.processDate1()
    };
  },
  computed: {
    getSourceType: function() {
      return this.$store.getters.sourceType;
    }
  },
  created() {
    // 将方法的指向转移
    this.historyForm.sourceType = this.getSourceType;
    const that = this;
    window.handleCancel = that.handleCancel;
    this.getOtherList();
    const params = this.sendParam({ timeStamp: new Date().getTime() });
    // getBankList(params).then(res => {
    //   res = this.paramDecrypt(res);
    //   this.bankOption = res.data;
    // })
    this.getSelectProType();
  },
  mounted() {
    // 添加撤销按钮
    // this.$nextTick(() => {
    //   if (this.getSourceType === '2') {
    //     const parent = this.$refs.reject.$el.children[1].children[0];
    //     const child = document.createElement('div');
    //     child.innerHTML = `<span class="rejectSpan">(已拒绝)</span>`;
    //     parent.append(child.firstChild);
    //   }
    // });
  },
  methods: {
    getOtherListSearch(val){
      this.historyForm.page = val
      this.getOtherList()
    },
    beginDate() {
      const self = this;
      return {
        disabledDate(time) {
          if (self.searchForm.endTime) {
            //如果结束时间不为空，则小于结束时间
            return new Date(self.searchForm.endTime).getTime() < time.getTime();
          } else {
            // return time.getTime() > Date.now()//开始时间不选时，结束时间最大值小于等于当天
          }
        }
      };
    },
    processDate() {
      const self = this;
      return {
        disabledDate(time) {
          if (self.searchForm.startTime) {
            //如果开始时间不为空，则结束时间大于开始时间
            return (
              new Date(self.searchForm.startTime).getTime() > time.getTime()
            );
          } else {
            // return time.getTime() > Date.now()//开始时间不选时，结束时间最大值小于等于当天
          }
        }
      };
    },
    beginDate1() {
      const self = this;
      return {
        disabledDate(time) {
          if (self.historyForm.endTime) {
            //如果结束时间不为空，则小于结束时间
            return (
              new Date(self.historyForm.endTime).getTime() < time.getTime()
            );
          } else {
            // return time.getTime() > Date.now()//开始时间不选时，结束时间最大值小于等于当天
          }
        }
      };
    },
    processDate1() {
      const self = this;
      return {
        disabledDate(time) {
          if (self.historyForm.startTime) {
            //如果开始时间不为空，则结束时间大于开始时间
            return (
              new Date(self.historyForm.startTime).getTime() > time.getTime()
            );
          } else {
            // return time.getTime() > Date.now()//开始时间不选时，结束时间最大值小于等于当天
          }
        }
      };
    },
    getSelectProType() {
      let params = {
        isUsed: 1
      };
      selectProType(this.sendParam(params)).then(res => {
        res = this.paramDecrypt(res);
        if (res.code == 200) {
          this.bankOption = res.data;
        }
      });
    },
    otherDown() {
      if (this.historyForm.status == null) {
        this.historyForm.status = "";
      }
      const xhr = new XMLHttpRequest();
      xhr.open(
        "post",
        this.baseUrl + "/api/credit/excel/expertProductApplyList",
        true
      ); // get、post都可
      xhr.responseType = "blob"; // 转换流
      xhr.setRequestHeader("token", sessionStorage.getItem("token")); // token键值对
      xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
      xhr.onload = function() {
        if (this.status === 200) {
          const blob = this.response;
          const fileName = "信易贷其他产品列表.xls";
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            const a = document.createElement("a");
            const url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
          }
        }
      };
      xhr.send(
        "deptName=" +
          this.historyForm.deptName +
          "&startTime=" +
          this.historyForm.startTime +
          "&endTime=" +
          this.historyForm.endTime +
          "&sourceType=" +
          this.historyForm.sourceType +
          "&status=" +
          this.historyForm.status
      );
    },
    getSearchList(val){
      this.searchForm.page = val
      this.getList()
    },
    getList() {
      getApplyList(this.sendParam(this.searchForm)).then(res => {
        res = this.paramDecrypt(res);
        if (res.code === 200) {
          if (res.data) {
            this.data = res.data.list;
            this.total2 = res.data.total;
            if (this.getSourceType === "1") {
              this.$nextTick(() => {
                const child = document.createElement("div");
                for (let i = 0; i < this.data.length; i++) {
                  const parent = this.$refs["cancel" + i][0].$el.children[1];
                  if (parent.children.length !== 3) {
                    child.innerHTML =
                      '<div class="cancelButton" onclick="handleCancel(' +
                      i +
                      ')">撤销</div>';
                    parent.append(child.firstChild);
                  }
                }
              });
            }
            // 状态检查
            if(this.data!=undefined){
              this.data.forEach(x => {
              if (x.status) {
                if (x.status === 3) {
                  x.checkStatus = 2;
                } else if (x.status === 5) {
                  x.checkStatus = 3;
                } else {
                  x.checkStatus = x.status;
                }
              }
              });
            }
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    //其他产品列表
    getOtherList() {
      list(this.sendParam(this.historyForm))
        .then(res => {
          res = this.paramDecrypt(res);
          if (res.code == 200) {
            this.tableData = res.data.list;
            this.total = res.data.total
          }
        })
        .catch(err => {});
    },
    // 申请时间范围
    handleTimeChange(timeRange) {
      this.searchForm.page = 1
      this.historyForm.page = 1
      // this.searchForm.startTime = timeRange && timeRange.length ? moment(timeRange[0]).format("YYYY-MM") : "";
      // this.searchForm.endTime = timeRange && timeRange.length ? moment(timeRange[1]).format("YYYY-MM") : "";
      this.getList();
    },
    //历史时间范围
    historyTimeChange(timeRange) {
      this.searchForm.page = 1
      this.historyForm.page = 1
      // this.historyForm.startTime = timeRange && timeRange.length ? moment(timeRange[0]).format("YYYY-MM") : "";
      // this.historyForm.endTime = timeRange && timeRange.length ? moment(timeRange[1]).format("YYYY-MM") : "";
      this.getOtherList();
    },
    // 申请金额范围
    handleMoneyChange(i) {
      this.searchForm.page = 1
      this.historyForm.page = 1
      switch (i) {
        case 1:
          this.searchForm.loanMinAmount = 0;
          this.searchForm.loanMaxAmount = 100;
          break;
        case 2:
          this.searchForm.loanMinAmount = 100;
          this.searchForm.loanMaxAmount = undefined;
          break;
        // case 3:
        //   this.searchForm.loanMinAmount = 100;
        //   this.searchForm.loanMaxAmount = 200;
        //   break;
        // case 4:
        //   this.searchForm.loanMinAmount = 200;
        //   this.searchForm.loanMaxAmount = 500;
        //   break;
        // case 5:
        //   this.searchForm.loanMinAmount = 500;
        //   this.searchForm.loanMaxAmount = undefined;
        //   break;
        default:
          this.searchForm.loanMinAmount = undefined;
          this.searchForm.loanMaxAmount = undefined;
      }
      this.getList();
    },
    handleChange() {
      this.searchForm.page = 1
      this.historyForm.page = 1
      this.getList();
    },
    historyChange() {
      this.getOtherList();
    },
    historyStatusChange() {
      this.searchForm.page = 1
      this.historyForm.page = 1
      this.getOtherList();
    },
    handleSubmit() {},
    handleCancel(index) {
      const params = {
        appId: this.data[index].id,
        operateType: "cancel",
        status: this.data[index].status
      };
      updateApply(this.sendParam(params)).then(res => {
        res = this.paramDecrypt(res);
        if (res.code === 200) {
          this.$message.success("撤销成功");
          this.getList();
        }
      });
    },
    formatTime(time) {
      return time ? moment(time).format("YYYY-MM-DD HH:mm") : "";
    },
    //切换tab
    // handleClick(event) {
    //   this.searchForm.page = 1
    //   this.historyForm.page = 1
    //   console.log(this.historyForm.page)
    //   if (event.name == "2") {
    //     this.getOtherList();
    //   } else if (event.name == "1") {
    //     this.getList();
    //   }
    // },
    //关注
    Focus(e, status) {
      let params = {
        operateType: status,
        id: e
      };
      operate(this.sendParam(params))
        .then(res => {
          res = this.paramDecrypt(res);
          if (res.code == 200) {
            this.getOtherList();
          }
        })
        .catch(err => {});
    }
  }
};
</script>

<style lang="less" scoped>
.bottomPart {
  width: 100%;
  background: #fff;
  box-sizing: border-box;
  padding-top: 20px;
  font-size: 14px;
  border-radius: 6px;
  margin-top: 20px;
  .titlePart {
    color: #2981ee;
    font-size: 24px;
    font-weight: bold;
    border-left: 6px solid #2981ee;
    padding-left: 20px;
    margin-bottom: 20px;
  }
  .contentListPart {
    padding: 20px;
    .contentItemPart {
      padding: 10px;
      display: flex;
      border-bottom: 1px solid #f3f4f9;
      .leftPart {
        display: flex;
        width: 50%;
        align-items: center;
        flex-direction: column;
        justify-content: space-around;
        .bankIcon {
          width: 80px;
          height: 80px;
          margin-right: 20px;
        }
        .textPart {
          display: flex;
          flex-direction: column;
          width: calc(100% - 100px);
          .title {
            font-size: 20px;
            font-weight: bold;
            color: #2a2a2a;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .textOuterPart {
            display: flex;
            margin-top: 10px;
            padding-right: 10px;
            font-size: 15px;
            color: #252525;
            justify-content: space-between;
            .textInnerPart {
              display: flex;
              flex-direction: column;
              span {
                font-size: 20px;
                font-weight: bold;
                color: #2a2a2a;
                display: inline-block;
                margin-right: 2px;
              }
            }
          }
        }
      }
      .rightPart {
        width: 50%;
      }
    }
  }
}
.bottomPartCompany {
  min-height: 740px;
}
.bottomPartBank {
  height: 134px;
}
.buttonPart {
  height: 60px;
  display: flex;
  justify-content: flex-end;
  background-color: #f4f9fe;
  button {
    margin-top: 10px;
    margin-right: 40px;
    height: 40px;
    background: #2981ee;
    color: #fff;
  }
}
.footPart {
  width: 100%;
  min-height: 536px;
  background: #fff;
  box-sizing: border-box;
  border-radius: 6px;
  padding: 30px;
  .companyList {
    .companyItem {
      display: flex;
      padding-bottom: 20px;
      border-bottom: 1px solid #f3f4f9;
      .leftPart {
        width: 50%;
        .titlePart {
          .title {
            color: #2a2a2a;
            font-size: 20px;
            font-weight: 550;
            margin-bottom: 6px;
          }
          .info {
            color: #252525;
            font-size: 15px;
            margin-bottom: 10px;
          }
        }
        .textOuterPart {
          display: flex;
          margin-top: 10px;
          padding-right: 10px;
          font-size: 15px;
          color: #252525;
          .textInnerPart {
            display: flex;
            flex-direction: column;
            margin-right: 50px;
            span {
              font-size: 20px;
              font-weight: bold;
              color: #2a2a2a;
              display: inline-block;
              margin-right: 2px;
            }
          }
        }
      }
      .rightPart {
        width: 50%;
      }
    }
  }
}
/deep/.el-steps {
  .el-step__line-inner {
    border-color: #dbdbdb;
  }
  .el-step__icon {
    color: #fff;
    top: -5px;
    border-width: 5px;
    box-sizing: content-box;
  }
  .is-finish .el-step__icon {
    background: #3bc37b;
    border-color: #bcecd2;
  }
  .is-process .el-step__icon {
    background: #2981ee;
    border-color: #abc9ef;
  }
  .is-error .el-step__icon {
    background: #f85b4b;
    border-color: #f2c8c3;
  }
  .is-wait .el-step__icon {
    background: #a7a7a7;
    border-color: #dbdbdb;
  }
  .el-step__title {
    font-size: 16px;
    font-weight: 540;
  }
  .el-step__title.is-finish {
    color: #3bc37b;
  }
  .el-step__title.is-process {
    color: #2981ee;
  }
  .el-step__title.is-error {
    color: #f85b4b;
  }
  .el-step__title.is-wait {
    color: #a7a7a7;
  }
  .el-step__description {
    padding-left: 10px !important;
    padding-right: 10px !important;
    color: #252525;
  }
  .cancelButton {
    color: #fff;
    font-size: 13px;
    padding: 4px 6px;
    background: #2981ee;
    border-radius: 4px;
    width: 30px;
    margin: 4px auto 0;
    cursor: pointer;
  }
  .rejectSpan {
    color: #f85b4b;
  }
}
</style>

<style lang="less" scoped>
/deep/ .el-tabs__nav-wrap::after {
  position: static !important;
}
.block2 {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}
/deep/ .el-tabs__header {
  padding: 0;
  position: relative;
  margin: 0px 0 15px;
  padding-left: 69px;
  background: #f3f4f9;
  .el-tabs__item.is-active {
    font-family: Alibaba PuHuiTi;
    font-weight: 600;
    color: #2a2a2a;
  }
}
.historyButton {
  padding: 0 40px;
  width: 100%;
  height: 66px;
  background: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #fc755f;
  box-sizing: border-box;
  opacity: 0.9;
  background: #fff9f8;
  div {
    display: flex;
    align-items: center;
    img {
      margin-right: 5px;
    }
  }
  .el-button {
    width: 157px;
    height: 40px;
    background: #2981ee;
    border-radius: 6px;
    font-size: 16px;
    font-family: Alibaba PuHuiTi;
    font-weight: 500;
    color: #ffffff;
  }
}
.historyTable {
  min-height: 590px;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  background-color: #fff;
}
/deep/ .el-table th {
  font-size: 16px;
  font-family: Alibaba PuHuiTi;
  font-weight: 400;
  color: #252525;
  text-align: center;
}
/deep/ .el-table td {
  font-size: 15px;
  font-family: Alibaba PuHuiTi;
  font-weight: 400;
  color: #252525;
  text-align: center;
}
</style>
